/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useState, useCallback, useEffect } from 'react'
import style from "./header.module.scss"
import { useReactRouter } from 'hooks/useReactRouter'
import ModifyPasswd from 'components/modifyPasswd'
import { useMappedState } from 'redux-react-hook'
// import { createAction, SET_MENU } from 'store/ActionTypes'
import Menu from './Menu'
import { Link, useHistory } from 'react-router-dom'
import { RouterPaths } from 'utils/constant'
import Btn from 'components/button'
import { clearLoginInfo } from 'service/sign'
import ModelFn from 'components/model/ModelFn'
import { Drawer } from 'antd'
import { isLogined, $userInfo } from 'service/sign'
import { getSearch,isMobile, toShop } from 'utils/utils'

function Header() {
  const { history, location } = useReactRouter()
  const coverClass = showCover(location.pathname) ? style.cover : ''
  const insign = inSign(location.pathname)

  const clickLogo = useCallback(() => {
    if (new RegExp('^/payment$').test(location.pathname)) {
      window.location.href = '/'
    } else {
      if (!window.location.href.includes('source=tv')) {
        history.push(RouterPaths.home)
      }
    }
  }, [history, location.pathname])

  return (
    <header
      className={style['g-header'] + ' ' + coverClass}>
      <div className={"container " + style.main}>
        <div onClick={clickLogo} className={style.left}>
          <img
            className={style.logo} src="/img/pic_logo_transocks@2x.png" alt="logo" />
          {/* 穿梭 <span className={style.font}>transocks</span> */}
          {/* <img className={style.trans} src={trans} alt="title"/> */}
        </div>
        <div className={style.right}>
          <div className={style.menu}>
            <a href="/">首页</a>
            <Link className={style.shop} to={RouterPaths.shop}>路由器</Link>
            <Link to={RouterPaths.home}>会员</Link>
            {/* <a href="https://www.transocks.com/zixun">资讯</a> */}
            {/* <a href="/affiliate.html">推广赚钱</a> */}
            {/* <a href="http://aitk.tdrsteam.com/#/homepage?channId=2007001cs&r=6" rel="noopener noreferrer" target="_blank">点卡代充</a> */}
            <div className={style.shopInfoBox}>
              <div className={style.shopInfo}>
                <div onClick={() => toShop('router_goods_detail')} className={style.infoItem}>立即购买</div>
                <div onClick={() => toShop('order_list')} className={style.infoItem}>我的订单</div>
                <div onClick={() => toShop('evaluated')} className={style.infoItem}>我的评价</div>
              </div>
            </div>
          </div>
          {
            insign || window.location.href.includes('source=tv') ? null : <UserInfo />
          }
        </div>
      </div>
    </header>
  )
}

function UserInfo() {
  const [showModify, setShowModify] = useState(false)
  const [userHead, setuserHead] = useState('/img/组 206.png')
  const [drawer, setdrawer] = useState(false)
  const [camilo,setcamilo] = useState(false)
  const [showMenu, logined] = useMappedState(state =>
    [
      state.user.showMenu,
      state.user.logined
    ]
  )
  // const dispatch = useDispatch()
  const history = useHistory()
  useEffect(() => {
    const width = document.body.offsetWidth
    // console.log(width)
    if (width <= 767) {
      setuserHead('/img/菜单.svg')
    }
  }, [])
  useEffect(() => {
    const icon = document.getElementById('icon')
    // console.log(icon)
    if (icon && drawer) {
      icon.style.display = 'none'
    } else if (icon && drawer === false) {
      icon.style.display = 'unset'
    }

  }, [drawer])
  useEffect(() => {
    if (isLogined() && getSearch('login-token') == null) {
      $userInfo().then(res => {
        res.status === 'ok' ? setcamilo(res.data.is_cd_key_partner) : setcamilo(false)
      })
    }
  },[])

  // const setShowMenu = useCallback((flag: boolean) => {
  //   dispatch(createAction(SET_MENU, flag))
  // }, [dispatch])

  // const switchMenu = useCallback((e: React.MouseEvent) => {
  //   e.preventDefault()
  //   e.stopPropagation()
  //   setShowMenu(true)
  // }, [setShowMenu, showMenu])

  // const leaveMenu = (e) => {
  //   e.preventDefault()
  //   e.stopPropagation()
  //   setShowMenu(false)
  // }
  // const showNick = useCallback(() => {
  //   if (userInfo) {
  //     if (userInfo.phone_num) {
  //       return userInfo.phone_num.replace(/[+-]/ig, '')
  //     }
  //     return userInfo.email || userInfo.nick
  //   }
  //   return ''
  // }, [userInfo])

  function signOut() {
    clearLoginInfo()
    isMobile() ? history.push(RouterPaths["signin-phone"]) : history.push(RouterPaths["signin-qr"])
  }
  const cancellation = () => {
    ModelFn.confirm({ text: '确定注销登录？', onConfirm: signOut })
    // document.onkeydown = function (e) {
    //   if (e.key === 'Enter') {
    //     // signOut()
    //     ModelFn.confirm.close
    //   }
    // } 
  }

  const openMenu = () => {
    if (userHead === '/img/菜单.svg') {
      // console.log(111)
      showDrawer()
    }
  }

  const showDrawer = () => {
    setdrawer(true)
  }
  const onClose = () => {
    setdrawer(false)
  }

  if (!logined) {
    return (
      // <div className={style['no-login']}>
      //   <Icon icon="iconicon_user_grey" className={style.icon} />
      //   {/* <Link to={RouterPaths["signin-phone"]} className={style['sign']}>登录</Link>
      //   <span className={style['cut-off']}>|</span>
      //   <Link to={RouterPaths["signin-phone"]} className={style['sign']}>注册</Link> */}
      //   <Link to={RouterPaths["signin-phone"]} className={style['sign']}>登录 / 注册</Link>
      // </div>
      <Btn
        title="登录"
        className={style.button}
        onClick={() => { isMobile() ? history.push(RouterPaths["signin-phone"]) : history.push(RouterPaths["signin-qr"]) }}
      />
    )
  }

  return (
    <div
      className={style['user-info']}
      style={{zIndex:101}}

    >
      <img onClick={() => openMenu()} src={userHead} alt="" id='icon' className={style.icon} />
      {/* 下拉框 */}
      <div className={style.userInfoBox}>
        <div className={style.usersInfo}>
          <div onClick={() => history.push(RouterPaths.userInfo)} className={style.infoItem}>账号信息</div>
          <div onClick={() => history.push(RouterPaths.records)} className={style.infoItem}>购买记录</div>
          <div onClick={() => history.push(RouterPaths.settings)} className={style.infoItem}>安全设置</div>
          <div onClick={() => history.push(RouterPaths.equipment)} className={style.infoItem}>登录设备</div>
          {
            camilo ? <div onClick={() => history.push(RouterPaths.camilo)} className={style.infoItem}>卡密信息</div> : null
          }
          <div className={style.infoItem} onClick={() => cancellation()}>注销登录</div>
        </div>
      </div>

      <Drawer
        title={null}
        placement="top"
        closable={false}
        onClose={onClose}
        visible={drawer}
        height={'100%'}
      // bodyStyle={{background:'rgba(32, 39, 43, 1'}}
      ><div className={style.drawer}>
          <div className={style.close}  >
            <img onClick={onClose} src="/img/关  闭.svg" alt="" />
          </div>
          <div className={style.menuContent}>
            <a href="/" >
              首页
            </a>
            <a href="/payment/shop" className={style.router}>
              路由器
            </a>
            <div className={style.shopInfo} onClick={() => toShop('router_goods_detail')}>
              立即购买
            </div>
            <div className={style.shopInfo} onClick={() => toShop('order_list')}>
              我的订单
            </div>
            <div className={`${style.shopInfo} ${style.evaluate}`} onClick={() => toShop('evaluated')}>
              我的评价
            </div>
            <a className={style.border} href="/payment">
              会员
            </a>
            {/* <a href="https://www.transocks.com/zixun" >
              资讯
            </a> */}
            {/* <a href="http://aitk.tdrsteam.com/#/homepage?channId=2007001cs&r=6" rel="noopener noreferrer" target="_blank" > 点卡代充 </a> */}
            {localStorage.UserInfo && <span onClick={() => history.push(RouterPaths.userInfo)} >
              账号信息
            </span>}
            {localStorage.UserInfo ? <span onClick={() => { onClose(); cancellation() }}>
              注销登录
            </span>
              : <a href={ isMobile() ? "/payment/signin-phone" : '/payment/signin-qr' } >
                登录
              </a>}
          </div>
        </div>

      </Drawer>
      {
        userHead === '/img/菜单.svg'
      }

      {
        showMenu
          ? (
            // <div  onMouseOver={switchMenu}>
            <Menu
              show={showMenu}
              closeMenu={() => { }}
              showModify={() => { }}
            />
            // </div>
          )
          : null
      }
      {/* 修改密码 */}
      {
        showModify
          ? (
            <ModifyPasswd
              show={showModify}
              onHide={() => setShowModify(false)}
            />
          )
          : null
      }
    </div>
  )
}



function showCover(path) {
  if (new RegExp('/sign').test(path)) {
    return false
  }
  return true
}

function inSign(path) {
  if (new RegExp('/sign').test(path)) {
    return true
  }
  return false
}

export default Header
